import { v4 as uuidv4 } from "uuid";

export const uuidWithProcessId = (processId: string) => {
  const uuidFromLibrary = uuidv4();
  return `${processId}__${uuidFromLibrary}`;
};

export const getProcessIdFromUUID = (uuid: string) => {
  const uuidArr = uuid.split("__");
  if (uuidArr.length >= 1) {
    return uuidArr[0];
  }

  return undefined;
};
